import { render, staticRenderFns } from "./enquete.vue?vue&type=template&id=2ccb49e7&scoped=true&lang=pug&"
import script from "./enquete.vue?vue&type=script&lang=js&"
export * from "./enquete.vue?vue&type=script&lang=js&"
import style0 from "./enquete.vue?vue&type=style&index=0&id=2ccb49e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb49e7",
  null
  
)

export default component.exports